import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import ButtonBase from '../../Buttons/ButtonBase';
import { Checkbox, RadioGroup, Radio, FormLabel, FormControlLabel } from '@material-ui/core';
import { connect } from 'react-redux';
import "./costForm.scss"

const styles = () => ({
  TextField: {
    maxWidth: '536px',
  },
  TextField_small: {
    width: '144px',
    marginRight: '24px',
  },
  Grid: {
    marginTop: 39,
  },
  input_icon: { maxWidth: '560px' },
});

let costArrangement = [
  { index: 0, value: '-500', label: "Menos de $500.- MXN" },
  { index: 1, value: '500-1000', label: "De $500.- a $1,000.- MXN" },
  { index: 2, value: '1000-2000', label: "De $1,000.- a $2,000.- MXN" },
  { index: 3, value: '2000-4000', label: "De $2,000.- a $4,000.- MXN" },
  { index: 4, value: '4000-', label: "Más de $4,000.- MXN" }
]

let typesOfRates = [
  { name: 'Por consultar', selected: true },
  { name: 'Precio por hora', selected: false },
  { name: 'Precio por asesoría o consulta', selected: false },
  { name: 'Precio por tipo de servicio', selected: false },
  { name: 'Precio cerrado', selected: false },
  { name: 'Precio por porcentaje de caso', selected: false }
];

const CostForm = props => {
  const [toTypesOfRates, setToTypesOfRates] = useState(typesOfRates);
  const [isValidData, setIsValidData] = useState(false)

  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    resetForm,
    touched,
    errors,
    isValid,
    isLawyer,
    classes,
    setFieldValue,
    evento,
    cost,
    membershipType
  } = props;

  useEffect(() => {
    values.typesOfRates && setToTypesOfRates(values.typesOfRates);
    values.consultingCost = 'yes';
    values.typesOfRates = toTypesOfRates;
  }, []);

  const handleChangeConsultingCost = field => event => {

    event.preventDefault();
    let value = event.target.value;

    setFieldValue(field, value);
    if (cost !== undefined && Object.entries(cost).length !== 0) {
      setIsValidData(false)
      let valid = toTypesOfRates.filter(element => element.selected === false);
    if (valid.length === 6) {
      setIsValidData(true)
    } else {
      setIsValidData(false)
    }
    }
  };

  const handleChangeCostRange = field => event => {
    event.preventDefault();
    let value = event.target.value;

    setFieldValue(field, value);
    if (cost !== undefined && Object.entries(cost).length !== 0) {
      setIsValidData(false)
      let valid = toTypesOfRates.filter(element => element.selected === false);
    if (valid.length === 6) {
      setIsValidData(true)
    } else {
      setIsValidData(false)
    }
    }
  }

  const handleChangeCheckCommunity = (rates) => {

    let array = toTypesOfRates.map(rate => {
      if (rate.name === rates.name) {
          rate.selected = !rate.selected
      }
      return rate;
    })


    if (values.consultingCost === 'yes') {
      setIsValidData(false)
    }
    if (values.consultingCost === 'no' && values.costRange !== undefined) {
      setIsValidData(false)
    }

    setToTypesOfRates(array)
    setFieldValue('typesOfRates', toTypesOfRates);
    handleValidationButton()
  }

  const handleValidationButton = () => {
          
    let valid = toTypesOfRates.filter(element => element.selected === false);
    if (valid.length === 6) {
      setIsValidData(true)
    } else {
      setIsValidData(false)
    }

  }

  const handleCancel = event => {
    event.preventDefault();
    if(cost === undefined){
      values.consultingCost = "yes";
      values.costRange = "Menos de $500.- MXN";
      let array = toTypesOfRates.map(rate => {
        rate.selected = false
        return rate;
      })
      setToTypesOfRates(array)
    }else {
      values.consultingCost = cost.consultingCost;
      values.costRange = cost.costRange;
      setToTypesOfRates(cost.typesOfRates)
    }
    setIsValidData(true)
  };


  const handleRenderCheckBoxCostRate = () => {
    return (
      <>
        {toTypesOfRates.map((rates, index) => {
          return (<div key={index} className="contentMain">
            <FormControlLabel
              classes={{
                root: classes.FormControlLabelRoot,
              }}
              control={
                <Checkbox
                  name={rates.name}
                  checked={rates.selected}
                  onChange={() =>
                    handleChangeCheckCommunity(rates)}
                  value={rates.name}
                  label="Gilad Gray"
                  classes={{
                    root: classes.checkPadding,
                  }}
                />
              }
              label={
                <p><span className="titleCheck">{rates.name}</span></p>
              }
            />
          </div>)
        })}
      </>
    )
  }

  return (
    <form>
      {values && values ?
        (<div>
          <p className={"textNumberOne"}>1. Primer asesoría</p>
          <p className={"adviceFree"}>
            ¿La primer asesoría es gratuita?
          </p>
          <div className="contentRadio">
            <RadioGroup
              row
              name="consultingCost"
              // defaultValue="yes"
              value={values.consultingCost === undefined ? 'yes' : values.consultingCost}
              onChange={handleChangeConsultingCost('consultingCost')}
              onBlur={handleBlur}
            >
              <FormControlLabel
                value="yes"
                control={<Radio color="secondary" />}
                label="Sí"
              />
              <FormControlLabel
                value="no"
                control={<Radio color="secondary" />}
                label="No"
              />
            </RadioGroup>
          </div>
          <p className={values.consultingCost === undefined || values.consultingCost === "yes" ? "priceRangeDisable" : "adviceFree"}>¿Dentro de qué rango está el precio promedio que manejas por asesoría?</p>
          {values.consultingCost === "no" && <p className={values.consultingCost === undefined || values.consultingCost === "yes" ? "priceRangeDisableRequest" : "adviceFreeResquest"}>Este valor es obligatorio*</p>}
          <div className="contentRadio">
            <RadioGroup
              name="costRange"
              // defaultValue="price0-500"
              value={values.costRange}
              onChange={handleChangeCostRange('costRange')}
              onBlur={handleBlur}
            >

              {costArrangement.map((priceData, index) => {
                return (<FormControlLabel key={index}
                  disabled={values.consultingCost === undefined || values.consultingCost === 'yes'}
                  value={priceData.label}
                  control={<Radio color="secondary" />}
                  label={priceData.label}
                />)
              })}
            </RadioGroup>
          </div>
          <p className={"textNumberOne"}>2. Tarifas</p>
          <p className={"adviceFree"}>
            ¿Cuáles son las tarifas que manejas?
          </p>
          <p className={"adviceFreeResquest"}>Selecciona al menos una de las siguientes opciones</p>
          {handleRenderCheckBoxCostRate()}
          <div className="addLawyers_horizontal-layout" style={{ marginTop: 15 }}>
            <ButtonBase
              type="submit"
              onClick={handleSubmit}
              variant="primary"
              disabled={isValidData}
              classes={{ root: classes.ButtonBase }}
              style={{ marginRight: 16 }}
            >
              Guardar Cambios
            </ButtonBase>
            <ButtonBase
              type="submit"
              onClick={handleCancel}
              variant="primaryOutlined"
              className={classes.ButtonBase}
              style={{ marginRight: 16 }}
            >
              Cancelar
          </ButtonBase>
          </div>
        </div>

        ) : (null)}


    </form>
  );
};


const mapStateToProps = state => ({
  uid: state.authClient.uid,
  cost: state.authClient.cost,
  authClient: state.authClient,
  membershipType: state.authClient.membership.type
});

const mapDispatchToProps = dispatch => ({
  
});

export default connect(mapStateToProps, mapDispatchToProps) (withStyles(styles)(CostForm));
